<template>
  <v-card>
    <div style="text-align: center; justify-content: center">
      <v-icon v-if="propId" class="ma-1 right top" style="position: absolute" color="#0D47A1" large
        @click="limpiarCampos(); $emit('propCerrarFormulario')">mdi-close-circle</v-icon>
      <div style="padding: 10px; margin-left: 10px; margin-right: 10px; border-radius: 5px">
        <div class="ml-4 mr-4" v-if="propId">
          <h1 style="line-height: 1.2; color: black; text-align: center">
            Formulario de Postulación
          </h1>
          <br>
          <h2>{{ propIndicacion }}</h2>
        </div>
        <br>
        <!-- -------------------- -->
        <div>
          <div>
            <h2>Nombre:</h2>
            <v-text-field v-model="formulario.nombre" outlined dense placeholder="Ingrese su nombre" />
          </div>
          <div style="margin-top: -15px;">
            <h2>Correo electrónico:</h2>
            <v-text-field v-model="formulario.correo" outlined dense placeholder="Ingrese su correo" />
          </div>
          <div style="margin-top: -15px;">
            <h2>Numero de Celular (con codigo):</h2>
            <v-text-field v-model="formulario.celular" outlined dense placeholder="Ingrese su correo" />
          </div>
          <div style="margin-top: -15px;">
            <h2>Mensaje:</h2>
            <v-textarea v-model="formulario.mensaje" placeholder="Ingrese contenido" outlined no-resize />
          </div>
          <v-btn style="margin-top: -15px;color: white" color="#0D47A1"
            @click="enviarSolicitud()">
            <h2>Enviar</h2>
          </v-btn>
        </div>
        <!-- -------------------- -->
      </div>
    </div>
  </v-card>
</template>
<script>
import axios from 'axios';
export default {
  props: {
    propId: { type: String },
    propIndicacion: { type: String },
    propAsunto: { type: String },
  },
  data() {
    return {
      formulario: {
        nombre: '',
        correo: '',
        celular: '',
        mensaje: '',
      },
      sms: "",
    };
  },
  mounted() { },
  watch: {
  },
  methods: {
    async enviarSolicitud() {
      if (!this.propAsunto) {
        this.propAsunto="contacto"
      }
      if (!this.formulario.nombre || !this.formulario.correo || !this.formulario.celular || !this.formulario.mensaje) {
        this.sms = "Faltan campos por llenar";
        alert("Faltan campos por llenar")
        return;
      }
      const form = new FormData();
      form.append("nombre", this.formulario.nombre);
      form.append("correo", this.formulario.correo);
      form.append("celular", this.formulario.celular);
      form.append("asunto", this.propAsunto);
      form.append("mensaje", this.formulario.mensaje);
      try {
        const response = axios.post('/crear_solicitud', form);
        if (response) {
         alert("ENVIADO")
         this.limpiarCampos()
         this.$emit('propCerrarFormulario')
        }
      } catch (error) {
                 alert("ERROR AL ENVIADO")

      }
    },
    splitDateTime(dateTime) {
      const [date, time] = dateTime.split(", "); // Divide en fecha y hora
      const [year, month, day] = date.split("/"); // Divide la fecha en partes
      const [hour, minute, second] = time.split(":"); // Divide la hora en partes

      return {
        year,
        month,
        day,
        hour,
        minute,
        second,
      };
    },
    setFields() {
      this.formulario.id = this.propCurso.id
      this.formulario.titulo = this.propCurso.titulo
      this.formulario.detalles = this.propCurso.detalles
      this.formulario.imagen = this.propCurso.image_path
      this.formulario.modalidad = this.propCurso.modalidad
      this.formulario.duracion = this.propCurso.duracion
      this.formulario.fecha_inicio = this.propCurso.fecha_inicio
      this.imagePreviewOld = this.propCurso.image_path
    },
    limpiarCampos() {
      this.formulario.nombre = ''
      this.formulario.correo = ''
      this.formulario.celular = ""
      this.formulario.mensaje = ''
    },
    genDate() {
      const options = {
        timeZone: "America/Guayaquil", // Configura la zona horaria de Guayaquil
        hour12: false, // Usar formato de 24 horas
      };

      const now = new Date();

      // Usar toLocaleString para obtener la fecha en la zona horaria especificada
      const year = now.toLocaleString("es-EC", { ...options, year: "numeric" });
      const month = String(
        now.toLocaleString("es-EC", { ...options, month: "2-digit" })
      ).padStart(2, "0");
      const day = String(
        now.toLocaleString("es-EC", { ...options, day: "2-digit" })
      ).padStart(2, "0");
      const hours = String(
        now.toLocaleString("es-EC", { ...options, hour: "2-digit" })
      ).padStart(2, "0");
      const minutes = String(
        now.toLocaleString("es-EC", { ...options, minute: "2-digit" })
      ).padStart(2, "0");
      const seconds = String(
        now.toLocaleString("es-EC", { ...options, second: "2-digit" })
      ).padStart(2, "0");
      return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style scoped></style>
